<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">
                    연혁일자
                </td>
                <td class="">
                    <div class="filter-select-div el-filter-date pt0 pb0">
                        <span class="filter-select-div el-filter-date">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                                class="el-date-common el-date-month"
                                v-model="date"
                                prefix-icon=" "
                                type="date"
                                format="yyyy-MM-dd "
                                value-format="yyyy-MM-dd "
                                placeholder="등록일"
                                @change="dateChange(date)"
                                clear-icon="none"
                                :picker-options="pickerOptions"
                        ></el-date-picker>
                        </span>
                        <div class="input_error" v-html="validation.firstError('date') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">연혁내용</td>
                <td>
                    <div>
                        <el-input type="textarea" rows="5" v-model="content" maxlength="200" @input="parentChange('content', content)"></el-input>
                        <div class="input_error" v-html="validation.firstError('content') "></div>

                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import historyValidator from "@/mixins/validators/historyValidator";
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";
    export default {
        name: "HistoryWriteDefaultLayout",
        mixins: [historyValidator,],
        components: {},
        inject: ['historyWriteSetData'],
        provide() {
            return {}
        },
        props: {
           historyData: {},
        },
        data() {
            return {
                pickerOptions: { //데이트피커 옵션
                    disabledDate(time) {
                        let nowDate = new Date();
                        return time.getTime() > nowDate;
                    },
                },
            }
        },
        created() {
        },
        mounted() {
            this.initData();
            EventBus.$on('HistoryWriteDefaultLayoutValidator', this.checkValidator);
        },
        beforeDestroy() {
            EventBus.$off('HistoryWriteDefaultLayoutValidator')

        },
        destroyed() {},
        computed: {
        },
        methods: {
            initData() {
                if(util.isEmpty(this.historyData)) {
                    return false;
                }

                this.content = this.historyData.ch_content;
                this.parentChange('content', this.content);
                this.date = this.historyData.ch_date;
                this.parentChange('date', this.$moment(this.date).format('YYYY-MM-DD'));

            },
            parentChange(key, value) {
                this.historyWriteSetData(key, value);
            },
            dateChange(date){
                this.parentChange('date', this.$moment(date).format('YYYY-MM-DD'));

            },
            checkValidator(dataArr) {
                this.$validate(dataArr)
            },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>